export default __webpack_public_path__ + "static/media/Rolling-1s-22px.5a958670.svg";